// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2tBad","text":"SelectPayment_text__QSFox","title":"SelectPayment_title__8SaJG","btn":"SelectPayment_btn__2qHwn"};